import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import TypeFieldEnum from './TypeFieldEnum';

class TableOpcao extends AbstractComponent {                 
    exibeCampo(item, itemHead) {        
        if(itemHead.campo !== 'valor')
            return item[itemHead.campo];

        if(item.type === undefined || item.type === '')
            return item[itemHead.campo];
        
        return TypeFieldEnum.get(item.type).format(item[itemHead.campo]);
    }

    className(item, itemHead) {
        if(this.props.onClassName === undefined)
            return '';

        return this.props.onClassName(item, itemHead);        
    }    
        
    render() {
        return (            
            <table className="table table-striped">
                <thead>
                    <tr>
                        {this.props.head.map((item, i) => {
                            return (
                                <th 
                                    key={i}                                    
                                    width={item.width}
                                >
                                    {item.nome}
                                </th>
                            )
                        })}

                        <th className="col-md-2" />
                    </tr>
                </thead>
                <tbody>
                    {
                        Array.isArray(this.props.body) && this.props.body.map((item, index) => {
                        return (
                            <tr key={index} className={(item.marcar ? 'table-checked' : '')}>
                                {this.props.head.map((itemHead, i) => {
                                    return (
                                        <td 
                                            key={i} 
                                            className={this.className(item, itemHead)}
                                        >
                                            {this.exibeCampo(item, itemHead)}
                                        </td>
                                    )
                                })}

                                <th className="text-right">                
                                    <button 
                                        className="btnDefault"
                                        type="button"                        
                                        onClick={() => this.props.onClick(item, index)}
                                    >
                                        <i className="fa fa-wrench" />
                                    </button>                                                
                                </th>
                            </tr>
                        )})
                    }
                </tbody>
            </table>            
        )
    }
}

TableOpcao.defaultProps = {
    codigo: 'id',
    disabled: false
};

export default  TableOpcao;